import { type TabItemBase } from '@redneckz/wildless-cms-uni-blocks/mobile/lib/ui-kit/TabsControl/TabItem';

export const TABS: TabItemBase[] = [
  { text: 'Главные новости', href: '/news' },
  { text: 'Новости регионов', href: '/news/filial' },
];

export const PREMIUM_ULTRA_TABS: TabItemBase[] = [
  { text: 'Новости', href: '/news/premium-ultra' },
  { text: 'Акции', href: '/news/premium-ultra/actions' },
];
